<template>
  <div :key="item.title">
    <!-- 视频 -->
    <video
      autoplay
      width="100%"
      @click.stop="chooseMuban(index, false)"
      class="hoverClass"
      :class="[{ active: item.isChoose }, item.className]"
      v-if="item.label == 'video'"
      :src="item.url ? item.url : videoUrl"
      :style="item.style"
    ></video>
    <!-- 图片 -->
    <el-image
      @click.stop="chooseMuban(index, false)"
      class="hoverClass imageClass"
      :class="[{ active: item.isChoose }, item.className]"
      v-if="item.label == 'image'"
      :src="item.src ? item.src : defaultPic"
      fit="cover"
      :style="item.style"
    ></el-image>
    <!-- 文本 -->
    <div
      @click.stop="chooseMuban(index, false)"
      class="hoverClass"
      :class="[{ active: item.isChoose }, item.className]"
      v-if="item.label == 'div'"
      :style="item.style"
    >
      {{ item.attribute == "custom" ? item.custom : item.title }}
    </div>
    <!-- 矢量图 -->
    <div
      @click.stop="chooseMuban(index, false)"
      class="hoverClass yh-iconfont"
      :class="[{ active: item.isChoose }, item.icon, item.className]"
      v-if="item.label == 'icon'"
      :style="item.style"
    ></div>
    <!-- 评分 -->
    <div
      @click.stop="chooseMuban(index, false)"
      class="hoverClass"
      :class="[{ active: item.isChoose }, item.className]"
      v-if="item.label == 'rate'"
      :style="item.style"
    >
      <el-rate :value="item.rate" disabled :colors="['#E33900', '#E33900', '#E33900']">
      </el-rate>
    </div>
    <!-- 列表 -->
    <div
      @click.stop="chooseMuban(index, false)"
      class="hoverClass flexList"
      :class="[{ active: item.isChoose }, item.className]"
      v-if="item.label == 'list'"
      :style="item.style"
    >
      <div v-for="(Item, _index) in 3" :key="_index">
        <div
          :style="item.htmlStyleList[0].style"
          :class="[
            { active: item.htmlStyleList[0].isChoose },
            item.htmlStyleList[0].className,
          ]"
          @click.stop="chooseSubMuban(index, 0)"
        >
          列表{{ _index }}
        </div>
      </div>
    </div>
    <!-- 栅格 -->
    <el-row
      class="rowhoverClass"
      v-if="item.label == 'row'"
      :class="[{ active: item.isChoose }, item.className]"
      :style="item.style"
    >
      <span @click.stop="chooseMuban(index, false)">
        <el-col
          :span="Item.col"
          v-for="(Item, _index) in item.htmlStyleList"
          :key="Item.id"
        >
          <video
            autoplay
            width="100%"
            @click.stop="chooseSubMuban(index, _index)"
            class="hoverClass"
            :class="[{ active: Item.isChoose }, Item.className]"
            v-if="Item.label == 'video'"
            :src="Item.url ? Item.url : videoUrl"
            :style="Item.style"
          ></video>
          <el-image
            :key="item.title"
            @click.stop="chooseSubMuban(index, _index)"
            :class="[{ active: Item.isChoose }, Item.className]"
            class="hoverClass"
            :style="Item.style"
            v-if="Item.label == 'image'"
            :src="Item.src ? Item.src : defaultPic"
            fit="cover"
          ></el-image>
          <div
            :key="item.title"
            v-if="Item.label == 'div'"
            :style="Item.style"
            class="hoverClass"
            @click.stop="chooseSubMuban(index, _index)"
            :class="[{ active: Item.isChoose }, Item.className]"
          >
            {{ Item.attribute == "custom" ? Item.custom : Item.title }}
          </div>
          <div
            @click.stop="chooseSubMuban(index, _index)"
            class="hoverClass yh-iconfont"
            :class="[{ active: Item.isChoose }, Item.icon, Item.className]"
            v-if="Item.label == 'icon'"
            :style="Item.style"
          ></div>
          <div
            @click.stop="chooseSubMuban(index, _index)"
            class="hoverClass"
            :class="[{ active: Item.isChoose }, Item.className]"
            v-if="Item.label == 'rate'"
            :style="Item.style"
          >
            <el-rate
              :value="Item.rate"
              disabled
              :colors="['#E33900', '#E33900', '#E33900']"
            >
            </el-rate>
          </div>
        </el-col>
      </span>
    </el-row>
  </div>
</template>
<script>
export default {
  props: { item: Object, index: Number },
  data() {
    return {
      videoUrl:
        "http://1251150518.vod2.myqcloud.com/8d224e9cvodgzp1251150518/a775f1ae3701925920751120030/4RPCJ58Vki4A.mp4",
      defaultPic:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
    };
  },
  methods: {
    chooseMuban(index, bol) {
      this.$emit("chooseMuban", index, bol);
    },
    chooseSubMuban(index, _index) {
      this.$emit("choosesubmuban", index, _index);
    },
  },
};
</script>
<style scoped>
.el-image {
  width: 100%;
}
.active {
  border: 1px dashed rgb(121, 117, 117) !important;
}
.hoverClass:hover {
  border: 1px dashed rgb(121, 117, 117);
}
.prefixHoverClass:hover {
  border: 1px dashed rgb(23, 85, 218);
}
.rowhoverClass:hover {
  border: 1px dashed rgb(38, 212, 212);
}
.imageClass {
  display: block;
  object-fit: cover;
  max-width: 100%;
  max-height: 100%;
}
.flexList {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineTemplate/template/index.vue